import { render, staticRenderFns } from "./SimpleTrain.vue?vue&type=template&id=32b04b23&"
import script from "./SimpleTrain.vue?vue&type=script&lang=js&"
export * from "./SimpleTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports